export default {
  "iso3": "dan",
  "iso2": "da",
  "text": {
    "100200": "Vi beklager, dette spil ser ud til at være begrænset i dit område.",
    "CURRENT_LANGUAGE": "Dansk",
    "CIP8_TITLE": "888CASINO SPIL",
    "Login": "LOG IND",
    "WITHDRAW": "UDBETAL",
    "CASHIER": "INDBETAL",
    "Search": "Søg efter dit spil...",
    "REWARDS": "Rewards",
    "HOME": "Start",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "TILMELD DIG",
    "DEPOSIT_SIDE_MENU": "Indbetal",
    "MY_ACCOUNT": "Min Konto",
    "BALANCE": "Din saldo",
    "MINI_ORBIT_BALANCE": "Saldo:",
    "LOGOUT": "Log ud",
    "GREETING_MORNING": "Godmorgen",
    "GREETING_AFTERNOON": "Goddag",
    "GREETING_EVENING": "Godaften",
    "GREETING_NIGHT": "Godnat",
    "GREETING_DEFAULT": "Hej",
    "MRS_TITLE": "Fru",
    "MR_TITLE": "Hr",
    "SLOTS": "Spilleautomater",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Jackpots & Automater",
    "CARD_TABLE_GAMES": "Kort- og bordspil",
    "CASINO_GAMES": "Casinospil",
    "LIVE_CASINO": "Live Casino",
    "PROMOTIONS": "Kampagner",
    "888SPORT": "888sport",
    "VIP_CLUB": "VIP Club",
    "PWA_INSTALL": "Installér app'en",
    "PWA_ADD_TO_HOME_SCREEN": "Tilføj startskærm",
    "PWA_TAP": "Tryk",
    "PWA_QUICK_LAUNCH": "Kviklancering {BRAND}",
    "BLOG": "Blog",
    "TODAY_WINNERS": "Dagens vindere",
    "SUPPORT_ID_MESSAGE": "Support-id",
    "DEPOSIT": "INDBETAL",
    "CHOOSE_LANG": "Vælg dit sprog:",
    "CHOOSE_COUNTRY": "Vælg dit land:",
    "SIGN_IN_PLAY": "LOG IND og SPIL",
    "NEW": "Ny",
    "JACKPOT": "Jackpot",
    "BRAND_EXCLUSIVE_FILTER": "{brandName} Eksklusive",
    "EXCLUSIVE": "888 Eksklusive",
    "SI_EXCLUSIVE": "SI Eksklusive",
    "1-25_LINES": "1-25 rækker",
    "25+_LINES": "25+ rækker",
    "888_EXCLUSIVE_GAMES": "888 Eksklusive spil",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "Eksklusive Casinospil!",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "888casino er stedet, hvor du finder et eksklusivt udvalg af online casinospil. Spil de hotteste online spilleautomater fra Section8 og nyd vores fantastiske casinospil såsom online roulette, online blackjack og video poker. Vores eksklusive casinospil tilbyder også Baccarat, Keno og spil med straks-gevinster. Gør klar til en masse sjov i vores casino-univers!",
    "INFO_TITLE_ARENA_SLOTS": "Online spilleautomater",
    "INFO_TEXT_ARENA_SLOTS": "Vælg mellem mere end 100 spilleautomater af bedste kvalitet, når du spiller online. Oplev en bred vifte af funktioner som bonusspil, ekspanderende wilds, ekstra spin og store jackpotter. Vil du erobre skatten i det gamle Ægypten, søge efter Leprechaun's krukke med guld, eller foretrækker du at holde det helt klassisk? Uanset hvilket tema du er til, så skal du nok finde dit favoritspil!",
    "INFO_TITLE_ARENA_CASINO": "Casinospil",
    "INFO_TEXT_ARENA_CASINO": "Kortene er blandet, hjulet drejer og din plads venter på dig. Spil kun de allerbedste kort- og bordspil online. Vælg mellem en række roulette-spil, herunder Europæisk, Amerikansk, Low, High og Super indsatser. Foretrækker du Blackjack? Spil flere hænder samtidigt. Sørg for at finde din pokerpræference fra Texas Hold’em til Caribbean!",
    "INFO_TITLE_ARENA_ROULETTE": "Roulette Online",
    "INFO_TEXT_ARENA_ROULETTE": "Prøv at ramme dine heldige numre på en af 888casinos førsteklasses online rouletteborde. Vælg mellem vores store udvalg af de bedste rouletteborde, herunder europæisk, amerikansk og fransk roulette. Uanset om du er High Roller eller foretrækker lave indsatser, har vi et roulettebord til dig. Der er intet som spændingen på at vente på, hvor kuglen lander, når du spiller roulette!",
    "INFO_TITLE_ARENA_NEW_GAMES": "Nye Spil",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack Online",
    "INFO_TEXT_ARENA_BLACKJACK": "Kortene er blandet, og din plads venter på nogle af de bedste online blackjack-spil, du vil spille! Spil blackjack på 888casino på dine egne vilkår med Super Stakes, Side Bets og mere. Er en hånd i blackjack ikke nok for dig? Spil vores Multihand Blackjack-spil, og få tre chancer for at ramme 21, samtidigt!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Videopoker online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "Hvis du mener, at du er ægte professionel pokerspiller, så er du kommet til det rigtige kasino! Prøv ar ramme den sjældne Royal Flush i vores forskellige videopokerspil. Hvis du mere er til 5-card draw eller foretrækker den altid populære Texas Hold’em, kan du finde din nye favorit online videopokerspil på 888casino.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Skrabelodder online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "Der er intet som en hurtig gevinst i et af 888casinos spændende skrabelodspil. Ideel til sjov uden strategi. Vælg et online skrabelod i dit temavalg. Afslør dine irske rigdomme, eller opdag faraos formue. Det er dit valg. Du skal blot vælge det beløb, du vil bette, og se, om du vinder på dit skrabelod!",
    "NETENT_SLOTS": "NETENT SPILLEAUTOMATER",
    "BONUS": "Bonus",
    "FREE_SPINS": "Gratis spins",
    "CLEAR_ALL": "Slet alt",
    "FILTER": "Filter",
    "APPLY": "Anvend",
    "ROULETTE": "Roulette",
    "BLACKJACK": "Blackjack",
    "BACCARAT": "Baccarat",
    "POKER": "Poker",
    "KENO": "Keno",
    "HIGH_LIMIT": "High Limit",
    "LANGUAGES": "Sprog",
    "HELP": "Hjælp",
    "LIVE_CHAT": "Live chat",
    "DEMO": "Demo",
    "PLAY": "Spil",
    "NOT_NOW": "Ikke nu",
    "MAYBE_LATER": "Ikke nu",
    "NO_THANKS": "Nej tak",
    "LETS_PLAY": "Lad os spille!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Grænser",
    "LIVE": "Live",
    "SEE_ALL": "Se alle",
    "WINNING_IN_THE_LAST_30_DAYS": "Gevinster de sidste 30 dage",
    "TOTAL_JACKPOTS": "Jackpots i alt",
    "TOP_GAMES": "BEDSTE SPILLEAUTOMATSPIL",
    "LIVE_CASINO_TABLES": "UDVALGTE LIVE-BORDE",
    "TOP_CASINO_GAMES": "BEDSTE CASINOSPIL",
    "JACKPOTS": "Jackpots",
    "RECENTLY_PLAYED": "Spillet for nylig",
    "BECAUSE_YOU_PLAYED": "Fordi du spillede {gameName}",
    "MINIMUM_BET": "Min. indsats",
    "MAXIMUM_BET": "Maks. indsats",
    "PAYLINES": "Gevinstrækker",
    "BONUS_GAME": "Bonusspil",
    "MAX_PER_SPOT": "Maks. pr. plads",
    "MULTIPLAYER": "Multiplayer",
    "DECKS": "Sæt kort",
    "SIDE_BETS": "Sideindsatser",
    "ABOUT": "Om",
    "GAME_JACKPOT": "Spil Jackpot",
    "SLOT_GAMES": "Spilleatomatspil",
    "CARD_AND_TABLE_GAMES": "Kort- og bordspil",
    "JACKPOT_GAMES": "Jackpot-spil",
    "JACKPOT_CENTRAL": "Alle med Jackpot",
    "OTHER": "Andet",
    "POKER_GAMES": "POKERSPIL",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "Ingen spil matchede din søgning",
    "PREMIER_ONLINE_LIVE_CASINO": "Premier live-casino",
    "All_SLOTS": "Alle spilleautomater",
    "All_CARD_AND_TABLE_GAMES": "Alle kort- og bordspil",
    "USEFUL_LINKS": "Nyttige links",
    "PRIVACY_POLICY": "Fortrolighedspolitik",
    "USER_AGREEMENT": "Brugeraftale",
    "RESPONSIBLE_GAMBLING": "Ansvarlig spil",
    "SAFE_ZONE": "Kontrolcentret",
    "CONTACT": "Kontakt os",
    "COMP_POINTS": "Bonuspoint",
    "HISTORY": "Historisk",
    "GAMING_HISTORY": "Spilhistorik",
    "TIPPING_HISTORY": "Tip-historik",
    "TIPPING_HISTORY_AMOUNT": "Tip-beløb",
    "MY_CHALLENGES": "Mine udfordringer",
    "SCRATCHCARDS": "Skrabelod",
    "QUICK_LINKS_TITLE": "HURTIGE LINKS",
    "NO_SEARCH_RESULTS": "Ingen søgeresultater fundet...",
    "SEARCH_YOUR_GAME": "Find spil, temaer, studier",
    "SEARCH_RESULTS_TITLE": "BEDSTE SØGERESULTATER",
    "SUGGESTED_GAMES": "FORESLÅEDE SPIL",
    "SUGGESTED_CATEGORIES": "FORESLÅEDE KATEGORIER",
    "BACK": "Tilbage",
    "HIT_THE_JACKPOT": "Ram jackpotten",
    "OUR_JACKPOTS": "VORES JACKPOTS",
    "MY_CLUB": "Min klub",
    "CASH_BALANCE": "Kontantsaldo",
    "BONUS_BALANCE": "Bonussaldo",
    "YOU_MAY_LIKE": "Du ville synes om",
    "TOP_PICKS_FOR": "BEDSTE VALG TIL {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "888poker",
    "BACK_TO_888POKER": "Tilbage til 888poker",
    "BACK_TO_888SPORT": "Tilbage til 888sport",
    "VIDEO_POKER_GAMES": "Videopokerspil",
    "VIDEO_POKER": "Videopoker",
    "SEO_IMAGE_CATEGORIES_TITLE": "Bedste {categoryName} oplevelse på 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "online casino - {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "LOW_ROLLERS": "Low Rollers",
    "TOP_NETENT_SLOTS": "TOP NETENT AUTOMATER",
    "PLAY_50_FREESPINS": "SPIL 30 NETENT REALSPIN",
    "HOLIDAY_GAMES": "SPIL I FERIEN",
    "ELITE_LOUNGE": "Elite-Lounge",
    "ORIGINALS": "888 Originaler",
    "RELATED_GAMES": "FORDI DU VALGTE: {gameName}",
    "DAILY_JACKPOT_GAMES": "Daglige jackpotspil",
    "CLASSIC_SLOTS": "Klassiske spilleautomater",
    "ALL_JACKPOTS": "ALLE JACKPOTS",
    "POPULAR_GAMES_TITLE": "Populære spil",
    "MORE": "Flere",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "888 DAGLIG JACKPOT",
    "HIGH_NOON_JACKPOT": "Middagstid-jackpot",
    "TWILIGHT_JACKPOT": "Tusmørke-jackpot",
    "POWER8_JACKPOT": "POWER 8-JACKPOT",
    "RED_TIGER_DAILY_JACKPOT": "RED TIGER'S DAGLIGE JACKPOT",
    "RED_TIGER_HOURLY_JACKPOT": "Red Tigers Hourly Jackpot",
    "PROGRESSIVE_JACKPOTS": "PROGRESSIVE JACKPOTTER",
    "INFO_TITLE_ARENA_JACKPOTS": "Jackpotter",
    "INFO_TEXT_ARENA_JACKPOTS": "Jackpot-spil kan give dig en særlig stor fortjeneste. Nogle jackpot-spil har ikke kun én progressiv jackpot, men to eller tre, som du kan vinde allesammen. Hos 888casino kan du spille mange jackpot-spil med forskellige design. Prøv lykken på en jackpot-spilleautomat og rejs tilbage til det gamle Ægypten, bevæg dig ind i den eventyrlig irske mytologi eller i rædselsverdenen på Elm Street. Det er mega-sjovt at spille på jackpot-maskinerne, og du kan blive mega-rig!",
    "INSTANT_GAMES": "Vind Spil Øjeblikkeligt",
    "INSTANT_WIN_GAMES_ARENA": "Vind Spil Øjeblikkeligt",
    "ALL_INSTANT_WIN_GAMES": "ALLE VIND SPIL ØJEBLIKKELIGT",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Vind Spil Øjeblikkeligt",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Straks-spil giver det hele på et øjeblik – det er sjov på sekundet. Gør dig klar til at spille de bedste skrabe-spil, som findes på kloden. Du kan boltre dig i spil som Volcano Eruption, Panda Mania og Merlin’s Millions. Er tiden knap men skal der alligevel ske noget sjovt? Bare rolig – prøv vores keno eller bingo-spil eller de sprudlende, hotte spil som Chicken Extreme, 7-UP og Epic Gems. Det er den helt store fest, og det bedste er, at du er inviteret! Det er uhyggelig let at spille straks-spil. Her behøver du ingen forudsætninger – det er bare; vælg, klik og vind!",
    "TRENDING_SLOTS": "DE NYESTE SPILLEAUTOMATER",
    "EXCLUSIVE_LIVE_TABLES": "EKSKLUSIVE LIVE-BORDE",
    "BLACKJACK_AND_ROULETTE_GAMES": "BLACKJACK- OG ROULETTESPIL",
    "ALL_888_EXCLUSIVE_GAMES": "ALLE 888 EKSKLUSIVE SPIL",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "Bordet åbner kl.",
    "LIVE_CASINO_TABLE_FULL_PC": "Bordet er fuldt",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Fuldt",
    "GAME_SHOWS": "Spillet viser",
    "TOP_EVO_GAMES": "Topspil",
    "FOR_YOU_GAMES": "TIL DIG",
    "VIRTUAL_SPORTS": "Virtuelt Sport",
    "LETS_PLAY_MONOPOLY": "Lad os spille Monopoly",
    "TOP_TRENDING_SLOTS": "Mest populære spilleautomater",
    "TOP_PAYING_SLOTS": "Spilleautomater med størst udbetaling",
    "RECENTLY_ADDED": "Tilføjet for nyligt",
    "TOP_SLOTS": "Bedste spilleautomater",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Virtuelt Sport",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Virtuelt Sport bringer dig en bred variant af computer-genererede sportskampe som du kan spille på døgnet rundt. Så hvorfor vente på den store kamp i aften, når du kan spille på vores virtuelle lige nu?",
    "REAL_MONEY_GAME": "Dette spil kan kun spilles med din kontantsaldo.",
    "NEW_GAMES_LIST_TITLE": "nye online casino spil",
    "NEW_GAMES": "Nye spil",
    "TOP_EXCLUSIVE_SLOTS": "Top Exclusive Slots",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 in your country",
    "CANT_CONNECT_ERROR_TITLE": "Kan ikke oprette forbindelse",
    "CANT_CONNECT_ERROR_MESSAGE": "Beklager, vi havde et teknisk uheld.",
    "RETRY": "PRØV IGEN",
    "TRANSACTION_HISTORY": "Transaktionshistorik",
    "REVERSE_WITHDRAWAL": "Annullering af udbetaling",
    "UPLOAD_DOCUMENTS": "Upload dokumenter",
    "HOTTEST_NEW_GAMES": "Mest populære nye spil",
    "BRAND_NEW": "Splinternye",
    "SINCE_LAST_MONTH": "Siden sidste måned",
    "FROM_LAST_MONTH": "From Last Month",
    "SAFE_GAMBLING_TOOLTIP": "Oplysninger om og værktøjer til ansvarligt spil",
    "GAME_POPUP_GAME_UNAVAILABLE": "Beklager, dette spil er ikke tilgængeligt",
    "GAME_POPUP_MAY_LIKE": "Du kan måske også lide:",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "HURRA! Du skal til at spille et {partyJackpotName}-spil!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "Jackpotten kan vindes på enhver cash saldoindsats.\n Alle Party Jackpot-præmier er bonusser, som øjeblikkeligt krediteres til din konto.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Enhver indsats med rigtige penge på et Party Jackpot-spil kan vinde en kontantpræmie!\nParty Jackpot udbetaler dagligt!",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: omsætningskrav 30x (varierer efter spiltype), udløber efter 90 dage, gevinster begrænses til 500 $, gælder for udvalgte spil",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Kun for spillere, der har indbetalt",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "Vilkår og betingelser gælder.",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "{jackpotName} på {winAmount} er lige blevet vundet!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Vandt du ikke? Ingen grund til at ærgre dig!\n Denne jackpot kan vindes hver time, {startHour}-{endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "DU VANDT {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "FANTASTISK!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Tilføj midler for at spille Live Casino Jackpot",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": " Live Casino Jackpot kan kun vindes med pengespil",
    "JACKPOT-WIDGET-MUST-PAY": "Skal betale inden:",
    "JACKPOT-WIDGET-DROPS-SOON": "FALDER SNART!",
    "JACKPOT-WIDGET-STARTS-SOON": "BEGYNDER SNART",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Start af næste jackpot",
    "JACKPOT-WIDGET-LAST-WIN": "Sidste gevinst",
    "IN-GAME-WIDGET-STARTS-SOON": "Begynder snart",
    "FREEPLAY_INDICATOR": "Ekstraspil",
    "OMG_INDICATOR": "Beskeder",
    "USER_LIKE_YOU": "TOP {topNumber} I {countryName}",
    "YOUR_COUNTRY": "Dit land",
    "CLOSE": "Luk",
    "LIVE_STREAM_WATCH_TIME_REACHED": "Klar til at kaste dig ud I at spille?",
    "LIVE_STREAM_VIDEO_LOADING": "Indlæser...",
    "PLAY_NOW": "SPIL",
    "CASINO": "CASINO",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Indbetaling behandles",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "Din {mftName}-skærm er stadig åben",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Fortsæt",
    "VOLATILE_SLOTS": "Volatile spilleautomater",
    "VOLATILE_GAMES": "Volatile spil",
    "HIGH_VOLATILITY_SLOTS": "Spilleautomater med høj volatilitet",
    "LOW_VOLATILITY_SLOTS": "Spilleautomater med lav volatilitets",
    "BURNOUT_MESSAGE_LINE_1": "SURPRISE!",
    "BURNOUT_MESSAGE_LINE_2": "YOU GOT A BONUS!",
    "CONGRATS": "Tillykke!",
    "YOUR_FP_ARE_WAITING": "Dit ekstra spil venter på dig her",
    "EXIT_POPUP_TITLE": "Du Kan Måske Også Lide",
    "DONT_SHOW_AGAIN_TEXT": "Vis ikke igen",
    "GAMING_HISTORY_NO_RECORDS": "Vi kunne ikke finde historikoversigter for dine spil",
    "GAMING_HISTORY_LAST_PAGE": "Der blev ikke fundet flere historikoversigter.",
    "GAMING_HISTORY_BET": "Indsats",
    "GAMING_HISTORY_WINNINGS": "Gevinster",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Gevinster*",
    "GAMING_HISTORY_BANKROLL": "Konto",
    "GAMING_HISTORY_MORE_DETAILS": "Flere oplysninger",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Kun tilgængelig på mobilenheder",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Kun tilgængelig på pc",
    "GAMING_HISTORY_FREE_PLAY_BET": "Indsats*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Gevinster*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Reward gevinster",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Reward konto",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "*Spillet med rewards",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "*Maks. gevinst",
    "GAMING_HISTORY_DAYS_INTERVAL": "Sidste {numberOfDays} dage",
    "GAME_PARTICIPATION_ID": "Deltager-id: {participationID}",
    "GAME_SESSION_ID": "Sessions-id: {sessionID}",
    "TSR_MENU_LINK_LABEL": "Påmindelse om tidsforbrug",
    "TSR_CONFIRM": "Fortsæt",
    "TSR_CLOSE_GAME": "Luk spil",
    "TSR_TITLE": "Påmindelse",
    "TSR_SESSION_TIME_TEXT": "Du har været logget på i:",
    "TSR_WINNINGS_TEXT": "Dine samlede gevinster:",
    "TSR_LOSSES_TEXT": "Dine samlede tab:",
    "IDLE_RECOMMENDATIONS_TITLE": "Kan du ikke beslutte dig for, hvad du vil spille?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "Du vil kunne lide:",
    "GAME_WINDOW_VENDOR_SESSION_ID": "Sessions-id: {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Pengespil",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Demo",
    "FREE_PLAY_VOUCHER_NAME_FPV": "Ekstraspil",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Ekstra spins",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "Jackpot Ekstraspil",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Jackpot spins",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Tilbageværende:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "Ekstraspil reward",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Ekstra spin reward",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Jackpot Ekstraspil reward",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Jackpot spins reward",
    "FREE_PLAY_VOUCHER_DESC_FPV": "Ekstra demospil, som du kan bruge i udvalgte spil efter eget ønske!",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Ekstra spins med forud definerede værdier du kan bruge i udvalgte spil!",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Kun Jackpot i Ekstraspil, som du kan bruge i udvalgte spil efter eget ønske!",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Kun Jackpot Ekstra spins med foruddefinerede værdier du kan bruge i udvalgte spil!",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Udløber om {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Udløbet",
    "FREE_PLAY_EXPIRES_IN_DAY": "Udløber om {expiration} dage",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "Held og lykke!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "Du har rewards, der venter på dig. Held og lykke!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "Dette spil kan også spilles med følgende rewards:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "Du kan bruge denne reward i spillet(ene) herunder.",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "Du har ikke flere rewards tilbage.",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Tilbage",
    "FREE_PLAY_SHOW_MORE": "Vis Mere",
    "FREE_PLAY_SHOW_LESS": "Vis Mindre",
    "FREE_PLAY_USE_NOW_BUTTON": "Brug nu",
    "FREE_PLAY_USE_LATER_BUTTON": "Brug senere",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "Du har rewards i dette spil!",
    "BONUS_ABUSE_PREVENTION_TITLE": "Afbrudt spil",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "Det ser ud som om, at et spil blev afbrudt ...\n Fuldfør venligst {gameName}, inden du kan begynde at spille {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Ikke nu",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Fuldfør spil",
    "OPEN_GAME_FROM_CHALLENGES": "Udfordringer kan ikke gennemføres vha. rewards.",
    "CANCEL": "Annullér",
    "YES": "JA",
    "NO": "Nej",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Åbn spil",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "Det ser ud til, at der stadigvæk er et spil åben....\n Vil du lukke {oldGameName} og begynde at spille {newGameName}?",
    "GAMES_OF_THE_WEEK": "Games Of The Week",
    "THE_FISH_MARKET": "The Fish Market",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Langsom forbindelse",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "Vi har registreret en langsom netværksforbindelse. Det kan tage lidt længere tid end forventet at åbne spillet.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Tilslutter...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Forbereder spil {packagesStatus}",
    "HELP_CENTER": "Hjælp",
    "ABOUT_TITLE": "Dine kontooplysninger",
    "ABOUT_SUPPORT_ID_TITLE": "Id til support",
    "ABOUT_FISCAL_CODE_TITLE": "Skattekode",
    "ABOUT_CLIENT_VERSION_TITLE": "Kundeversion",
    "ABOUT_HELP_SUPPORT": "Ved forespørgsler og support henvises du til vores online hjælp",
    "ABOUT_OPEN_SESSION_TITLE": "Åbn sessionssaldoen",
    "OK": "OK",
    "INSUFFICIENT_FUNDS_TITLE": "Utilstrækkelig saldo",
    "INSUFFICIENT_FUNDS_MESSAGE": "Din aktuelle saldo er ikke tilstrækkelig til at spille dette spil. Hvis du vil fortsætte med at spille, skal du først foretage en indbetaling til kassen.",
    "OPEN_CASHIER": "Åbn kassen",
    "GAME_LIMIT_REAL_MONEY_WARNING_MESSAGE": "Dette spil kan kun spilles med din kontantsaldo.",
    "GAME_NET_POSITION_LABEL": "Spilsaldo",
    "GAME_DURATION_LABEL": "Spillets varighed",
    "GAME_LIMIT_TITLE": "Vælg pengene i spillet",
    "REGULATORY_LIMIT_LABEL": "Lovgivningsmæssig grænse",
    "OTHER_LIMIT_LABEL": "Andet",
    "GAME_LIMIT_VALUE_ERROR": "Ugyldigt beløb. Prøv igen",
    "GAME_LIMIT_REGULATION_ERROR": "Maks. beløb er {regulationLimit}. Prøv igen.",
    "GAME_LIMIT_MIN_BET_ERROR": "Beløbet er under bordets minimum. Prøv igen",
    "Adventure": "Eventyr",
    "Ancient Civilization": "Ældgammel civilisation",
    "Arabic": "Arabisk",
    "Asian": "Asiatisk",
    "Classic Style": "Klassisk stil",
    "Comics and Cartoons": "Tegneserier og tegnefilm",
    "Diamonds and Gems": "Diamanter og ædelsten",
    "Egyptian": "Egyptisk",
    "Fantasy and Folklore": "Fantasy og folklore",
    "Farm and Pets": "Bondegår og dyr",
    "Fish": "Fisk",
    "Fruit and Candy": "Frugt og slik",
    "Greek Mythology": "Græsk mytologi",
    "Irish": "Irsk",
    "Money and Leisure": "Penge og fritid",
    "Movies and Music": "Film og musik",
    "Seasonal": "Sæsonbestemt",
    "Space and Sci-fi": "Rummet og science fiction",
    "Wildlife": "Dyreliv",
    "GAME_STUDIOS": "Spilstudier",
    "THEMES": "Temaer",
    "GAME_FEATURES": "Funktioner",
    "GAME_CATEGORIES": "Kategorier",
    "FILTER_BY": "Filtrer efter",
    "NO_JACKPOT": "Ingen jackpot",
    "HIGH_STAKES": "Høje indsatser",
    "LOW_STAKES": "Lave indsatser",
    "MULTIHAND": "Flerhåndsspil",
    "LIVE_BACCARAT": "Live-baccarat",
    "LIVE_POKER": "Live-poker",
    "LIVE_GAME_SHOWS": "Live-spilshows",
    "CRAPS": "Craps",
    "LIVE_ROULETTE": "Live Roulette",
    "MEDIUM_VOLATILITY": "Middelstor volatilitet",
    "VOLATILITY": "Volatilitet",
    "HIGH_VOLATILITY": "Høj volatilitet",
    "SPEED_GAMES": "Lynhurtige Spil",
    "generic_notification_popup_title": "Meddelelse",
    "MDP_INACTIVITY_DISCONNECTED_TEXT": "Du er blevet frakoblet pga. inaktivitet.",
    "RICH_USER_NOT_LOGGED_IN": "For at se dine udfordringer, skal du logge ind",
    "temp_account_title": "Verificér din konto",
    "temp_account_days_left": "Dage Tilbage",
    "temp_account_upload_btn": "Verificér konto",
    "MENU_ITEM_ABOUT": "Om",
    "MENU_ITEM_GAMING_REMINDERS": "Påmindelse om spiltid",
    "MENU_ITEM_TOUCH_ID": "Biometrisk log-in",
    "MENU_ITEM_INACTIVITY_TIMEOUT_SETTINGS": "Indstillinger",
    "MENU_ITEM_HYBRID_INFO": "Info",
    "MENU_ITEM_CASHIER_VERIFY_ID": "Bekræftelse af identitet",
    "TOUCH_ID_SUB_CAPTION": "Denne funktion vil blive aktiveret, næste gang du logger ind",
    "TOUCH_ID_CAPTION": "Du kan logge hurtigere ind ved at bruge funktionerne Touch ID eller Face ID på din enhed.",
    "TERMS_AND_CONDITIONS": "Servicebetingelser",
    "TOUCH_ID_INIT_SCREEN_ENABLE_BUTTON": "AKTIVÉR NU",
    "TOUCH_ID_AUTO_SCREEN": "LOG IND MED TOUCH-/FACE-ID",
    "kick_reason_general": "Du er blevet logget af din konto",
    "kick_reason_20": "Du er blevet logget af din konto, da du logger ind fra et andet sted",
    "TOUCH_ID_INFO": "<li>Ved aktivering af funktionen til Touch-/Face-id på denne enhed kan alle, hvis fingeraftryk er gemt på enheden, få fuld adgang til din 888-konto. Du bør ikke fortsætte med at oprette denne funktion, hvis der er gemt andre fingeraftryk end dine egne, på enheden.</li><li>Ved at bruge Touch-/Face-id til at få adgang til din 888-konto, accepterer du, at du alene er ansvarlig for alle transaktioner på din konto, uanset om disse transaktioner foretages af en tredjepart eller alle personer med et fingeraftryk gemt på denne enhed.</li><li>Derudover er du enig i, at operatøren af applikationen og dets tilknyttede partnere (sammen med \"888-gruppen\") ikke er ansvarlige over for dig ved eventuelle konsekvenser ved brug af Touch-/Face-id for at få adgang til din 888-konto. 888-gruppen kan ikke holdes ansvarlig for tab, ansvar, skader, udgifter eller omkostninger, der opstår ved brug af denne funktion.</li><li>For hver 888-applikation du har på din enhed, kan kun én af dine konti konfigureres til, når som helst, at logge ind med Touch-/Face-id.</li><li>Du vil blive bedt om at logge ind vha. din adgangskode, når Touch-/Face-id-godkendelsen mislykkes eller udløber.</li><li>888-gruppen lagrer ikke dine fingeraftryk på serverne, og håndterer eller understøtter ikke Touch-/Face-id teknologi.</li>",
    "ONBOARDING_WELCOME_STEP_MAIN_TEXT": "Flere spil. Større jackpots. Personlig oplevelse",
    "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT": "Klar til at udforske dit nye hjem?",
    "ONBOARDING_MENU_STEP_MAIN_TEXT": "Denne magiske menu tager dig direkte til alt det sjove",
    "ONBOARDING_MENU_STEP_SECONDARY_TEXT": "Jackpots, slots, LIVE borde & kampagner",
    "ONBOARDING_USER_AREA_MAIN_TEXT": "Kontroller din konto på ét sted",
    "ONBOARDING_USER_AREA_SECONDARY_TEXT": "Konto-ID, transaktionshistorik, bonusoversigt & mere",
    "DONE": "Færdig",
    "NEXT": "Næste",
    "TABLE_GAMES": "Bordspil",
    "ARCADE": "Arkade",
    "SPORTS": "Sport",
    "SCRATCH_CARDS": "Skrabelodder",
    "MEXICAN": "Mexicansk",
    "BINGO": "Bingo",
    "CLASSIC_STYLE_MODERNIZED": "Moderniseret klassisk stil",
    "AZTEC_INCA_MAYAN": "Aztek Inka Maya",
    "CRIME": "Kriminalitet",
    "WILD_WEST": "Det vilde vesten",
    "CANDY_AND_SWEETS": "Slik og søde sager",
    "GOLD_MINING": "Guldgravning",
    "VIKINGS_AND_NORDIC_MYTHOLOGY": "Vikinger og nordisk mytologi",
    "XMAS": "Jul",
    "JACKPOT_WIDGET_TITLE": "",
    "LAST_LOGIN_TITLE": "Sidst logget ind:",
    "SESSION_TIMER_TITLE": "Sessionstid",
    "LIVE_SLOTS": "Live Slots",
    "THE_BOOK_SHELF": "The Book Shelf",
    "LUCKYTAP_GAMES": "LuckyTap Games",
    "VEGAS_SLOTS": "Vegas Slots",
    "MUSIC_TO_MY_EARS": "Music to my ears",
    "GENIES_JACKPOT": "Genie's Jackpot",
    "NEW_LIVE_CASINO_GAMES": "New Live Casino Games",
  }
}